import { CanDeactivateFn } from '@angular/router';
import { AnnouncementEditComponent } from '../../features/announcements/announcement-edit.component';

export const announcementEditCanDeactivateGuard: CanDeactivateFn<AnnouncementEditComponent> = (
  component
) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }
  return window.confirm(
    'You have unsaved changes. If you leave now, your changes will be lost. Continue?'
  );
};
